import { DateTime } from "@bounce/date"
import { useTranslation } from "@bounce/i18n"
import { getNextStatusTime, isOpenNow, parseOpeningHours, parseOpeningHoursExceptions } from "@bounce/store"

import { StoreCardTag } from "./StoreCardTag"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

type StoreCardOpenStatusProps = {
  store: Pick<NearbyStorageSpot, "city" | "openingHours" | "openingHourExceptions">
}

export const StoreCardOpenStatus = ({ store }: StoreCardOpenStatusProps) => {
  const { t, i18n } = useTranslation()

  const isOpen = isOpenNow(store)
  const statusText = isOpen
    ? t("cmp.storeCard.openStatus.open", "Open")
    : t("cmp.storeCard.openStatus.closed", "Closed")
  const nextStatusTime = getNextStatusTime({
    currentDate: DateTime.fromObject({}, { zone: store.city.timezone }),
    openingHours: parseOpeningHours(store.openingHours),
    openingHourExceptions: parseOpeningHoursExceptions(store.openingHourExceptions),
    isStoreOpen: isOpen,
    locale: i18n.language,
  })
  const nextStatusTimeText =
    nextStatusTime === "24/7" ? t("cmp.storeCard.openStatus.nextStatusTime.247", "24/7") : `(${nextStatusTime})`
  const label = [statusText, nextStatusTime ? nextStatusTimeText : ""].join(" ")

  return <StoreCardTag bgColor={isOpen ? "green" : "neutral"} text={label} />
}
